import { render, staticRenderFns } from "./H5PageLayout.vue?vue&type=template&id=fbe97f5c&scoped=true&lang=pug&"
import script from "./H5PageLayout.vue?vue&type=script&lang=ts&"
export * from "./H5PageLayout.vue?vue&type=script&lang=ts&"
import style0 from "./H5PageLayout.vue?vue&type=style&index=0&id=fbe97f5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe97f5c",
  null
  
)

export default component.exports